import React from "react";

function ResultsSkeleton() {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20"
        >
          <div className="h-32 animate-pulse bg-slate-200 dark:bg-white/10" />
          <div className="space-y-4 p-4">
            <div className="h-5 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
            <div className="grid grid-cols-3 gap-2">
              <div className="h-16 animate-pulse rounded-2xl bg-slate-100 dark:bg-white/10" />
              <div className="h-16 animate-pulse rounded-2xl bg-slate-100 dark:bg-white/10" />
              <div className="h-16 animate-pulse rounded-2xl bg-slate-100 dark:bg-white/10" />
            </div>
            <div className="h-28 animate-pulse rounded-[1.5rem] bg-slate-100 dark:bg-white/10" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default ResultsSkeleton;